import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_LOGO_FULL_SRC } from '../../config/brandAssets';

interface FooterLinkProps {
  to?: string;
  href?: string;
  text: string;
}

const FooterLink: React.FC<FooterLinkProps> = ({ to, href, text }) => {
  const classes =
    'rounded-lg py-1 text-sm text-primary-light-300 transition-colors hover:text-ratuj-200 focus-outline';
  if (to) {
    return (
      <li>
        <Link to={to} className={classes}>
          {text}
        </Link>
      </li>
    );
  }
  return (
    <li>
      <a href={href} className={classes}>
        {text}
      </a>
    </li>
  );
};

const FooterLP: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-primary-dark-300/65 bg-primary-dark-200 px-4 pb-8 pt-10 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-7xl">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-[1.2fr_0.8fr_0.8fr]">
          <div>
            <Link
              to="/"
              className="mb-4 flex items-center gap-2 text-lg font-bold text-primary-light-100 transition-colors hover:text-ratuj-200 focus-outline"
            >
              <img src={BRAND_LOGO_FULL_SRC} alt="" className="h-7 w-7 object-contain" />
              Ratuj Sprzęt
            </Link>
            <p className="max-w-sm text-sm leading-6 text-primary-light-300">
              Powstająca lokalna sieć napraw. Serwisy mogą dołączyć wcześnie, pokazać się klientom i
              współtworzyć kierunek produktu.
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-primary-light-100">Na stronie</h4>
            <ul className="space-y-2">
              <FooterLink href="#for-services" text="Dla serwisów" />
              <FooterLink href="#for-customers" text="Dla klientów" />
              <FooterLink href="#jak-budujemy" text="Jak budujemy" />
              <FooterLink href="#wspoltworzenie" text="Współtworzenie" />
              <FooterLink href="#kontakt" text="Kontakt" />
              <FooterLink to="/bezpieczenstwo" text="Bezpieczeństwo" />
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-primary-light-100">Aplikacja</h4>
            <ul className="space-y-2">
              <FooterLink to="/register/service" text="Dołącz jako serwis" />
              <FooterLink to="/map" text="Mapa serwisów" />
              <FooterLink to="/login" text="Logowanie" />
              <FooterLink href="mailto:kontakt@ratujsprzet.pl" text="kontakt@ratujsprzet.pl" />
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-primary-dark-300/65 pt-6">
          <p className="text-sm text-primary-light-400">
            &copy; {currentYear} Ratuj Sprzęt. Wszelkie prawa zastrzeżone.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterLP;
